import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { ServicesInteractive } from "@/components/ServicesInteractive";
import { GardenFinder } from "@/components/GardenFinder";
import { CtaBand } from "@/components/CtaBand";
import { Marquee } from "@/components/Marquee";
import { FaqSection } from "@/components/FaqSection";
import { RevealLines } from "@/components/Reveal";
import { ATMO } from "@/config/site";

export default function Leistungen() {
  return (
    <>
      <Seo
        title="Leistungen | Gartengestaltung & Landschaftsbau Bremen – Hanse Garten Bremen"
        description="Leistungen in Bremen: Gartenplanung, Landschaftsbau, Terrassen, Pflasterung, Bepflanzung und Gartenpflege – Gestaltung, Bau und Pflege aus einer Hand."
        path="/leistungen"
        image={ATMO.stein}
      />
      <PageHero
        eyebrow="Leistungen"
        titleLines={["Was wir", "bauen."]}
        text="Planung, Umsetzung und Pflege aus einer Hand – für Privatgärten und Außenanlagen in Bremen und Umgebung."
        image={ATMO.stein}
        breadcrumb="Leistungen"
      />

      <section className="bg-[#F3EDE2] py-24 md:py-36">
        <div className="mx-auto max-w-[1480px] px-5 md:px-10">
          <ServicesInteractive />
        </div>
      </section>

      <Marquee />

      <section className="bg-[#DCCDB4]/30 py-24 md:py-32">
        <div className="mx-auto max-w-[1200px] px-5 md:px-10">
          <GardenFinder />
        </div>
      </section>

      <section className="bg-[#F3EDE2] py-24 md:py-32">
        <div className="mx-auto grid max-w-[1200px] gap-12 px-5 md:px-10 lg:grid-cols-[0.75fr_1.25fr]">
          <div>
            <p className="eyebrow">FAQ</p>
            <RevealLines
              lines={["Gut zu wissen."]}
              as="h2"
              className="display-xl mt-5 text-[10vw] leading-[0.92] text-[#17251C] md:text-[3.4vw]"
            />
          </div>
          <FaqSection />
        </div>
      </section>

      <CtaBand />
    </>
  );
}
